<template lang="pug">
  .module-preview
    v-row.mb-5
      v-col
        v-card(
          flat
        ).d-flex.align-center.justify-center
          .text-center
            v-icon(color="secondary" size=100) mdi-account-off
            .grey--text Без сопровождения
            p {{ moduleItem.price_per_user }} ₽
      v-col
        v-card(
          flat
        ).d-flex.align-center.justify-center
          .text-center
            v-icon(color="secondary" size=100) mdi-account
            template(v-if="moduleItem.is_escorted")
              .grey--text С сопровождением
              p {{ moduleItem.price_escort_per_user }} ₽
            template(v-else)
              .grey--text Сопровождение недоступно
              v-icon mdi-lock-outline
      v-col
        .d-flex.fill-height.justify-center.align-center
          .text-center(v-if="!subscribed")
            v-btn(
              color="secondary"
              x-large
              :disabled="subscribed"
              :loading="subscribe.loading"
              @click="subscribeToModule"
            ).mb-2 Подключить
            .caption Уже подключили
            strong  {{ $tc('organizations', moduleItem.accepted_users_count) }}
          .text-center(v-else)
            v-icon(size="30" color="success") mdi-check-bold
            .mt-5 Вы подключили данный модуль

    v-sheet(color="grey lighten-4").pa-5
      .grey--text Описание
      .mt-2 {{ moduleItem.description }}

    .d-flex.my-3.mx-4
      .grey--text Список тем
      v-spacer
      div
        span Всего -
        strong  {{ $tc('units', moduleItem.course_units_count) }}
    v-skeleton-loader(
      v-if="units.loading"
      type="list-item@3"
    )
    div(v-else)
      p.grey--text(v-if="!units.items.length") У модуля нет тем...
      lazy-load(
        v-model="units.loadMore"
        @on-response="({ items }) => units.items.push(...items)"
      )
        v-expansion-panels(flat)
          v-expansion-panel(
            v-for="item in units.items"
            :key="item.id"
          )
            v-expansion-panel-header.py-0
              div {{ item.title }}
            v-expansion-panel-content
              v-list
                v-list-item(v-for="(lesson, idx) in item.lessons" :key="lesson.id")
                  v-list-item-content
                    v-list-item-title Урок {{ idx + 1 }}
                    v-list-item-subtitle  {{ lesson.name }}
</template>

<script>
export default {
  name: 'ModulePreview',
  props: {
    // Instance Module.js
    moduleItem: { type: Object, required: true },
    subscribed: { type: Boolean, default: false },
  },
  data() {
    return {
      units: {
        items: null,
        loadMore: null,
        loading: null,
      },
      subscribe: {
        value: null,
        is_escorted: false,
        loading: false,
      },
    };
  },
  created() {
    this.fetchUnits();
  },
  methods: {
    async fetchUnits() {
      this.units.loading = true;
      const { items, loadMore } = await this.$api.modules.courseUnits(this.moduleItem.id, {
        expand: 'lessons',
      });
      this.units.items = items;
      this.units.loadMore = loadMore;
      this.units.loading = false;
    },
    async subscribeToModule() {
      this.subscribe.loading = true;
      await this.$api.modules.request(this.moduleItem.id)
        .then(() => {
          this.$toasted.success('Модуль успешно подключен');
          this.$modals.close();
          this.$router.push({ name: 'ModulesStockMy' });
        })
        .catch(() => {});
      this.subscribe.loading = false;
    },
  },
};
</script>
